import {
  BundleItemType,
  BundleStatus,
  GetCollectionParentOffersQuery,
  useGetCollectionParentOffersQuery,
} from 'generated/graphql';
import { Async } from '@client/new/helpers/types';
import { Collection } from '../collection.domain';
import { ColorsVars } from '@design-system/vars.css';
import { Sprinkles } from '@design-system/sprinkles.css';
import { orderBy } from 'lodash';

export type OfferDetails = {
  id: number;
  title: string;
  bgColor: ColorsVars;
  opacity: Sprinkles['opacity'];
};

export type UsePricingModel = {
  offers: OfferDetails[];
  currentPrice: number | null;
  creatorId: number;
};

export type PricingModelParams = {
  creatorId: number;
  collection: Collection;
};

export const usePricingModel = ({
  creatorId,
  collection,
}: PricingModelParams): Async<UsePricingModel> => {
  const { data: rawOffers } = useGetCollectionParentOffersQuery({
    variables: {
      input: {
        itemType: BundleItemType.Program,
        itemId: collection.id,
      },
    },
  });

  const price = collection.exclusiveProgramMetadata?.price || null;

  return {
    type: 'fetched',
    value: {
      offers: mapRawOffersToOffersDetails(rawOffers?.parentBundlesByItem || []),
      currentPrice: price ?? null,
      creatorId,
    },
  };
};

const mapRawOffersToOffersDetails = (
  rawOffers: GetCollectionParentOffersQuery['parentBundlesByItem'],
) => {
  return orderBy(rawOffers, ['status', 'id'], ['desc', 'desc']).map(
    (offer) => ({
      id: offer.id,
      title: offer.title,
      bgColor:
        offer.status === BundleStatus.Published
          ? 'G-40'
          : offer.status === BundleStatus.Archived
          ? 'ERROR-20'
          : ('D-40' as ColorsVars),
      opacity:
        offer.status === BundleStatus.Archived
          ? '0.5'
          : ('1' as Sprinkles['opacity']),
    }),
  );
};
